import cookie from 'js-cookie'

export const defaultLang = 'en'

export const locales = [
  {
    code: 'en',
    value: 'en_US',
    title: 'English',
  },
  {
    code: 'zh-hant',
    value: 'zh_TW',
    title: '繁體中文',
  },
  {
    code: 'ja',
    value: 'ja_JP',
    title: '日本語',
  },
  {
    code: 'ko',
    value: 'ko_KR',
    title: '한국어',
  },
  {
    code: 'es',
    value: 'es_ES',
    title: 'Español',
  },
  {
    code: 'vi',
    value: 'vi_VN',
    title: 'Tiếng Việt',
  },
  {
    code: 'id',
    value: 'id_ID',
    title: 'Bahasa Indonesia',
  },

  {
    code: 'it',
    value: 'it_IT',
    title: 'Italiano',
  },
  {
    code: 'ru',
    value: 'ru_RU',
    title: 'Русский язык',
  },
  {
    code: 'zh-CN',
    value: 'zh_CN',
    title: '简体中文（马来西亚）',
  },
  {
    code: 'km',
    value: 'km_KH',
    title: 'ភាសាខ្មែរ',
  },
  {
    code: 'hi',
    value: 'hi_IN',
    title: 'हिन्दी',
  },
  {
    code: 'th',
    value: 'th_TH',
    title: 'ภาษาไทย',
  },
  {
    code: 'fr',
    value: 'fr_FR',
    title: 'Français',
  },
  {
    code: 'ar',
    value: 'ar_SA',
    title: 'العربية',
  },
]

export const meiQiaLocalMap = {
  'zh-hant': 'tw',
  'zh-CN': 'cn',
  'en': 'en',
  'ko': 'ko',
  'ja': 'ja',
  'vi': 'vi',
  'id': 'indonesian',
  'it': 'it',
  'ru': 'ru',
  'km': 'km',
  'hi': 'hi',
  'th': 'th',
  'fr': 'fr',
  'ar': 'ar',
}

export const dialingLocaleMap = {
  zh: '+86', // 简中 + 繁中都默认 +86
  en: '+1', // 英文
  ko: '+82', // 韩文
  ja: '+81', // 日文
  id: '+62', // 印度尼西亚文
  it: '+39', // 意大利
  ar: '+20', // 阿拉伯语
  ru: '+7', // 俄语
  es: '+34', // 西班牙语
  km: '+855', // 高棉语（柬埔寨
  th: '+66', // 泰语（泰国）
  hi: '+91', // 印地语（印度）
  vi: '+84', // 越南语（越南）
}
export const defaultDialingCode = '+65'

export function getRestLocale(locale = defaultLang) {
  return locales.find(({ code }) => code === locale)?.value
}

export function getHeaderLang() {
  if (typeof window === 'undefined')
    return defaultLang
  const reg = new RegExp(`^\/(${locales.map(i => i.code).join('|')})\/?`, 'i')
  const match = location.pathname.match(reg) ?? []
  return match[1] || defaultLang
}

export function getLocale() {
  return cookie.get('i18n_redirected') ?? defaultLang
}
